import React, { useEffect, useState } from 'react';

export interface IDisclosure {
  button: JSX.Element;
  children: JSX.Element;
  defaultOpen: boolean;
}

export const Disclosure: React.FC<IDisclosure> = ({
  button,
  chevronIcon,
  children,
  isOpen,
  defaultOpen,
  onClick,
}) => {
  const [show, setShow] = useState(!!isOpen);

  const handleOnClick = () => {
    setShow(!show);
  };

  useEffect(() => {
    setShow(!!isOpen);
  }, [isOpen]);

  useEffect(() => {
    setShow(!!defaultOpen);
  }, [defaultOpen]);

  return (
    <>
      <button
        type='button'
        onClick={onClick || handleOnClick}
        className='flex items-center justify-between w-full ease-out duration-300'>
        {button}
        {chevronIcon && (
          <div className='flex border rounded-full border-gray-400 p-1 items-center'>
            <div
              className={`${
                show ? 'transform rotate-180 ease-out duration-300' : ''
              } ease-out duration-300`}>
              {chevronIcon}
            </div>
          </div>
        )}
      </button>
      <div
        className={`${
          show ? 'opacity-100' : 'opacity-0 pointer-events-none h-0'
        }  transition-opacity duration-500`}>
        {children}
      </div>
    </>
  );
};
